import _ from 'lodash';
import { Filters, SortingMethod } from '@common/types';
import {
  ACTIONS,
  useTemplatesContext,
} from '@components/Contexts/TemplatesContext';
import { useQuery } from '@tanstack/react-query';
import { queryKeyFrom } from '@utils/queryUtils';
import { TemplateQueryResponse } from '@common/types';
import {
  useErrorMonitor,
  useHttpClient,
  useTranslation,
} from '@wix/fe-essentials-standalone';
import { ENGLISH_LANGUAGE_CODE } from '@utils/constants';

export const useTemplatesQuery = (
  filters: Partial<Filters>,
  currentPage: number,
  sort: SortingMethod,
  pageSize?: number,
) => {
  const httpClient = useHttpClient();
  const errorMonitor = useErrorMonitor();
  const {
    i18n: { language },
  } = useTranslation();
  const shouldTranslateSearchTerm = language !== ENGLISH_LANGUAGE_CODE;
  const { dispatch } = useTemplatesContext();

  return useQuery({
    queryKey: queryKeyFrom(filters, currentPage, sort, false),
    queryFn: async () => {
      try {
        dispatch({
          type: ACTIONS.LOADING,
        });

        const { data } = await httpClient.post<TemplateQueryResponse>(
          '/api/templates',
          {
            ...filters,
            page: currentPage,
            sort,
            pageSize,
            shouldTranslateSearchTerm,
          },
        );

        dispatch({
          type: ACTIONS.INITIALIZED,
        });

        return data;
      } catch (err) {
        errorMonitor.captureException(err as Error);

        dispatch({
          type: ACTIONS.ERROR,
        });
      }
    },
  });
};
